module.exports = __webpack_public_path__ + "img/weixin.dc1be2cc.png";